import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router";
import {
  Container, WideContainer,
  Row,
  Col, ColBr,
  Img,
  Button,
  Link,
  Breadcrumb, BreadcrumbItem, BreadcrumbSeparator
} from './StyledComponents.js'
import styled from 'styled-components'
import { useQuery, gql } from '@apollo/client'
import loadable from '@loadable/component'

import {BsChevronLeft, BsChevronRight, 
  BsChevronDoubleLeft, BsChevronDoubleRight} from 'react-icons/bs'
import {RiScissorsCutLine, RiFileDownloadFill, RiAddFill, RiShareFill} from 'react-icons/ri'
import {MdCancel, MdDone} from 'react-icons/md'

import { useLocation, useHistory } from "react-router-dom"
import moment from 'moment'
import {Helmet} from "react-helmet-async"
import { FacebookShareButton, FacebookIcon,
  PinterestShareButton, PinterestIcon, 
  TwitterShareButton, TwitterIcon,
  WhatsappShareButton, WhatsappIcon,  
} from "react-share"
import { useIntl, FormattedMessage } from "react-intl"
import { useCookies } from 'react-cookie'
import 'react-image-crop/dist/ReactCrop.css'
import 'react-inner-image-zoom/lib/styles.min.css'
import InnerImageZoom from 'react-inner-image-zoom'
import { ScrollMenu } from "react-horizontal-scrolling-menu"
import { range } from "lodash"
import { generatePath } from "react-router"

import useSsr from './useSsr'
import altTextKes from './utils/altTextKes'
import UstBannerAd from './components/ads/UstBannerAd'
import ZoomImageModal from './components/ZoomImageModal'
import {loggedInContext} from './auth/AuthContext'
import DownloadPatreonModal from './components/DownloadPatreonModal'
import AddToCollectionModal from './components/AddToCollectionModal.js'
import CreateCollectionModal from './components/CreateCollectionModal.js'
import Spinner from './components/Spinner'
import useTenant from './client/useTenant'
import {useCsEvent} from './client/useEvents'


const ReactCrop = loadable(() => import('react-image-crop')) 
const queryString = require('query-string');

const H1 = styled.h1`
  margin: 0.25rem 0 0.25rem 0;
  font-size: 1.25rem;
`
const GunButonu = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  -webkit-transition: color .15s;
  transition: color .15s;
  border-color: #343a40;
  padding: .25rem .5rem;
  font-size: .875rem;
  line-height: 1.5;
  border-radius: .2rem;

  &:hover {
    background-color: #343a40;
    border-color: #343a40;
  }
  a {
    color: #343a40;
  }
  a:hover {
    color: #fff;
  }
  ${props => props.disabled ? `
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;

    * {
      color: #6c757d;
    }
  ` : ''}
`
const ActionButton = styled(GunButonu)`
  display: flex;
  flex-direction: row;
  margin-right: 0.5em;
  padding: 0px;
  padding-right: 0.5em;
  margin-top: auto;
  margin-bottom: auto;
`

const BreadCrumbNav = styled.nav`
  background-color: transparent;
  padding: 0;
  margin-bottom: 0.5rem;
`
const KupurImg = styled(Img)`
  max-height: 300px;
  object-fit:contain;
`
const EsasSayfaImg = styled(InnerImageZoom)`
  & img {
    object-fit:contain;
  }
`
const SayfaImg = styled(Img)`
  object-fit:contain;
`
const SayfaImageContainer = styled(Col)`
  @media (max-width: 576px) {
    padding: 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 500px;
  max-height: 2000px;
  position: relative;
`

const BboxOverlay = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 0, 0.2);
  pointer-events: none;
  z-index: 1;
`

const Metin = styled(Row)`
  font-size: 0.8em;
  background-color: rgb(246, 246, 246);
  white-space: pre-line;
  word-break: break-word;
  max-height: 200px;
  overflow: scroll;
`
const GunSayisiCol = styled.div`
  height: 100%;
  width: 250px;
  margin-right: .5em;
  border: 1px solid #d4e2e6;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px; /* future proofing */
  -khtml-border-radius: 10px; /* for old Konqueror browsers */

  :hover {
    background-color: #d4e2e6bf;
  } 
`
const DigerSayfaLink = styled.div`
  min-width: 5em;
  border: 1px solid #d4e2e6;
  justify-content: center;
  display: flex;
  margin: 0 .5rem 0 0;
  padding: .5rem;
  min-height: 50px;
  border-radius: 15px;

  a, span {
    margin-top: auto;
    margin-bottom: auto;
  }
`
const FormButton = styled(Button)`
    font-family: NeueEinstellungBold;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    font-size: 1.6rem;
    background-color: rgb(139, 125, 101);
    border: 0.1rem solid rgb(139, 125, 101);
    color: white;
    outline: 0px;
    display: block;
    font-weight: 500;
}
`
const LimitBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1em;
  height: 40px;
  margin-right: 0.5em;
  background: #fffbe6;
  border: 2px solid #8b7d65;
  border-radius: 8px;
  font-weight: bold;
  color: #8b7d65;
  font-size: 1.1em;
  white-space: nowrap;
  min-width: 60px;
`

const gqlQuery = gql`
  query GazeteSayfasi($gazete: String!, $tarih: Date!, $sayfa: Int!) {
    sayfa(gazete: $gazete, tarih: $tarih, sayfa: $sayfa) {
      caption,
      alt_text,
      dosya,
      last_updated,
      kupurler {
        id,
        dosya,
        icerik
      },
      etiketler,
      limit,
      censored,
    },
    sayi(gazete: $gazete, tarih: $tarih) {
      oncekiGun,
      sonrakiGun,
      toplamSayfa
    },
    gazete(gazete: $gazete) {
      gazete,
      gorunen_ad,
      dil,
      type
    },
    tarih(gun: $tarih) {
      sayilar {
        thumbnail,
        sayfa,
        gazete
      }
    },
    gazeteler {
      gazete,
      gorunen_ad
    }
  }
`

const oncekiSayfaEventFire = (fireCsEvent) => {
  fireCsEvent({
    category: "Sayfa",
    action: "Navigation",
    label: "Onceki Sayfa"
  })
}
const sonrakiGunEventFire = (fireCsEvent) => {
  fireCsEvent({
    category: "Sayfa",
    action: "Navigation",
    label: "Sonraki Gun"
  });
}
const pinterestShareEvent = (fireCsEvent) => {
  fireCsEvent({
    category: 'Sayfa',
    action: 'Share',
    label: 'Pinterest'
  });
}

// Add a BackToTopButton styled component
const BackToTopButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
  background: #8b7d65;
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  cursor: pointer;
  font-size: 2rem;
  transition: background 0.2s;
  &:hover, &:focus {
    background: #a08e6c;
    outline: 2px solid #fffbe6;
  }
`;

function GazeteSayfasi(props)  {
  let {gazete, tarih, sayfa} = props.match.params
  sayfa = parseInt(sayfa || 1)
  const {isSsr, context: ssrContext} = useSsr()
  const location = useLocation()
  const history = useHistory()
  const intl = useIntl()
  const [cookies, setCookie] = useCookies(['sayfa_view_count'])
  const [showZoomView, setShowZoomView] = useState(false)
  const [shareUrl, setShareUrl] = useState(null)
  const [renderCount, setRenderCount] = useState(0) 
  const { loggedIn, openLoginModal, user } = React.useContext(loggedInContext) 
  const [showCrop, setShowCrop] = useState(false)
  const [showPatreonModal, setShowPatreonModal] = useState(false)
  const [showAddToCollection, setShowAddToCollection] = useState(false)
  const [showCreateCollection, setShowCreateCollection] = useState(false)
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const [crop, setCrop] = useState({ unit: '%', width: 50, height: 50, x: 25, y: 25 })
  const tenant = useTenant()
  const fireCsEvent = useCsEvent()
  const queryParams = queryString.parse(location.search)

  let bbox = null;
  try {
    bbox = queryParams.bbox ? JSON.parse(queryParams.bbox) : null
  } catch (err) {
    console.error("Bbox parsing error, do nothing", err)
  }

  const {loading, data} = useQuery(gqlQuery, 
    {variables: {gazete, tarih, sayfa}})

  const {gazete: gazeteInfo, sayfa: sayfaData, 
    tarih: tarihData} = data || {};
  const kupurData = sayfaData?.kupurler
  const {sayilar: gunSayilari} = tarihData || {}
  const gazeteler = data?.gazeteler?.reduce((accu, gazete) => {
    accu[gazete.gazete] = gazete
    return accu
  }, {})
  
  console.debug("[GazeteSayfasi] render")

  if (!loading && !sayfaData && isSsr) {
    ssrContext.notFound = true
  }

  //her url değişimde zoom stateini sifirla
  useEffect(() => {
    setShowZoomView(!!queryParams.zoom)
  }, [queryParams.zoom])

  useEffect(() => {
    try {
      const sayfaViewCount = parseInt(cookies['sayfa_view_count']) || 0 
      setCookie('sayfa_view_count', sayfaViewCount+1, 
        {path: '/', maxAge: 3600*24*7})
    } catch(err) {
      console.error(err)
    }
    setShareUrl(typeof window !== 'undefined' && window.location.href)
    setRenderCount(renderCount+1)
  }, [gazete, tarih, sayfa])

  useEffect(() => {
    //fire a cs event if limit reached zero
    if (sayfaData?.limit === 0) {
      fireCsEvent({
        category: "Sayfa",
        action: "Engagement",
        label: "0 sayfa limiti görüldü."
      })
    }
  }, [sayfaData?.limit])

  const onCropClick = () => {
    if (sayfaData?.limit == 0 || sayfaData?.censored) {
      fireCsEvent({
        category: "Sayfa",
        action: "Eylem",
        label: "Kes butonuna basıldı, ancak sayfa kısıtlı"
      })
      return
    }

    fireCsEvent({
      category: "Sayfa",
      action: "Eylem",
      label: "Kes butonuna basildi"
    })
    setShowCrop(true)
  }

  const onCropDone = () => {
    //get dimensions
    console.debug(crop)

    fireCsEvent({
      category: "Sayfa",
      action: "Eylem",
      label: "Kes eylemi tamamlandı"
    })

    let url = new URL(window.location.href)
    history.push({pathname: url.pathname, 
      search: `?zoom=${crop.x},${crop.y},${crop.width},${crop.height}`})

    //reset crop state
    setShowCrop(false)
  }
  
  const onZoomClose = () => {
    let url = new URL(window.location.href)
    history.push({pathname: url.pathname})
  }

  const onAboneOlClick = () => {
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Abone ol button click"
    })
    if (!loggedIn) {
      const cta = "Abone olmak için üye olun veya giriş yapın"
      openLoginModal(cta)
      return
    }
    if (!user?.abonelik) {
      setShowPatreonModal(true)
      return 
    }
  }

  const onDownloadClick = () => {
    console.debug("[GazeteSayfasi] onDownloadClick")
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Download button click"
    })
    if (!loggedIn) {
      // Improved CTA with translation support
      const cta = (
        <FormattedMessage
          id="GazeteSayfası.downloadCta"
        />
      );
      openLoginModal(cta)
      return
    } 
    if (!user?.abonelik) {
      setShowPatreonModal(true)
      return 
    }

    //dosyayı aynı tabde download et
    window.open(`${process.env.REACT_APP_GA_API_URL}/indir/${gazete}/${tarih}/${sayfa}`, "_self")
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Download started"
    })
  }

  const onAddClick = () => {
    fireCsEvent({
      category: "Sayfa",
      action: "Engagement",
      label: "Add to collection clicked"
    })
    if (!loggedIn) {
      const cta = "Üye olarak gazete sayfalarından koleksiyonlar oluşturabilirsiniz."
      openLoginModal(cta)
      return
    }
    setShowAddToCollection(true)
  }
    
  const renderTip = React.useCallback(() => {
    return gazeteInfo.type === 'gazete' ? "Gazetesi" : "Dergisi";
  }, [gazeteInfo?.type]) 

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setImageDimensions({
      width: naturalWidth,
      height: naturalHeight
    });
    console.log('Image dimensions:', naturalWidth, 'x', naturalHeight);
  };

  // Back to top button state
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return <React.Fragment>
    {showPatreonModal && <DownloadPatreonModal onClose={() => setShowPatreonModal(false)} />}
    {showAddToCollection && <AddToCollectionModal 
      item={{gazete, sayfa, tarih}}
      onClose={() => setShowAddToCollection(false)}
      onCreate={() => setShowCreateCollection(true)}
    />}
    {showCreateCollection && <CreateCollectionModal 
      item={{gazete, sayfa, tarih}} 
      onClose={() => setShowCreateCollection(false)} 
    />}
    {!sayfaData && loading &&
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255,255,255,0.92)',
        zIndex: 2000
      }}>
        <Spinner />
        <span role="status" aria-live="polite" style={{fontSize: '1.2rem', color: '#8b7d65', marginTop: 24}}>
          <FormattedMessage id="yükleniyor" defaultMessage="Yükleniyor..." />
        </span>
      </div> }

    { showZoomView && sayfaData && sayfaData.limit != 0 && <ZoomImageModal
        dosya={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`}
        dims={queryParams.zoom?.split(",")}
        onCloseModal={onZoomClose} /> }

    {!loading && gazeteInfo && <Helmet htmlAttributes={{itemscope:"" , itemtype:"http://schema.org/Article"}}>
      <title>{intl.formatMessage({id: "GazeteSayfası.meta.title"}, {ad: gazeteInfo.gorunen_ad, tarih: moment(tarih).format('LL'), sayfa} )}</title>
      <meta name="description" 
        content={`${altTextKes(sayfaData.caption?.trim() || sayfaData.alt_text?.trim(), 300) || intl.formatMessage({id: "GazeteSayfası.meta.description", defaultMessage: "{tarih} Tarihli {ad} {tip} Sayfa {sayfa}"}, {ad: gazeteInfo.gorunen_ad, tip: renderTip(), tarih: moment(tarih).format('LL'), sayfa})}`}/>
      <meta itemProp="headline" 
          content={`${altTextKes(sayfaData.alt_text?.trim(), 110) || intl.formatMessage({id: "GazeteSayfası.meta.headline", defaultMessage: "{tarih} Tarihli {ad} {tip} Sayfa {sayfa}"}, {ad: gazeteInfo.gorunen_ad, tip: renderTip(), tarih: moment(tarih).format('LL'), sayfa})}`} />
      <meta name="og:title" itemProp="name" 
          content={intl.formatMessage({id: "GazeteSayfası.og.title", defaultMessage: "{tarih} Tarihli {ad} {tip} Sayfa {sayfa}"}, {ad: gazeteInfo.gorunen_ad, tip: renderTip(), tarih: moment(tarih).format('LL'), sayfa})} />
      <meta name="og:description" 
          content={`${altTextKes(sayfaData.caption?.trim() || sayfaData.alt_text?.trim(), 300) || intl.formatMessage({id: "GazeteSayfası.meta.description", defaultMessage: "{tarih} Tarihli {ad} {tip} Sayfa {sayfa}"}, {ad: gazeteInfo.gorunen_ad, tip: renderTip(), tarih: moment(tarih).format('LL'), sayfa})}`} />
      <meta name="og:image" content={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`} />
      <meta name="twitter:card" content={`summary_large_image`} />
      <meta name="twitter:image" content={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`} />
      <meta name="twitter:description" 
          content={`${sayfa}. Sayfa'yı oku`} />
      <meta name="twitter:title" 
          content={`${moment(tarih).format('LL')} Tarihli ${gazeteInfo.gorunen_ad} ${renderTip()}`} />
      <meta itemProp="datePublished" content={moment(tarih).format()} />          
      <meta itemProp="dateModified" content={moment(parseInt(sayfaData.last_updated)).format()} />
    </Helmet>}
    {!loading && sayfaData && gazeteInfo &&
      <Container>
        <Row><Col>
        <BreadCrumbNav className="d-flex" aria-label="breadcrumb">
          <Breadcrumb className="m-auto">
            <BreadcrumbItem>
              <Link to={`/gazete/${gazete}`}><span>{gazeteInfo.gorunen_ad}</span></Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator>›</BreadcrumbSeparator>
            <BreadcrumbItem>
              <Link to={`/gazeteSayisi/${gazete}/${moment(tarih).format('YYYY-MM-DD')}`}
                onClick={() => {fireCsEvent({
                  category: "Sayfa",
                  action: "Navigation",
                  label: "Sayi breadcrumb"
                })}}
              >
                {moment(tarih).format('YYYY-MM-DD')}
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator>›</BreadcrumbSeparator>
            <BreadcrumbItem aria-current="page">
              <FormattedMessage id="GazeteSayfası.sayfa" 
                defaultMessage={"Sayfa {sayfa}"} values={{sayfa}} />
            </BreadcrumbItem>
          </Breadcrumb>
        </BreadCrumbNav>
        </Col></Row>
        <Row><Col>
          <H1 className='d-flex justify-content-center'>
            <FormattedMessage id="GazeteSayfası.title" 
              defaultMessage="{tarih} Tarihli {ad} {tip} Sayfa {sayfa}"
              values={{tarih: moment(tarih).format('LL'), ad: gazeteInfo.gorunen_ad, tip: renderTip(), sayfa}} />
          </H1>
        </Col></Row>
        <link itemProp="mainEntityOfPage" href={history.createHref({pathname: location.pathname})} />
        <Row><Col className='d-flex justify-content-center align-middle mt-1 mb-1'>
          <GunButonu 
              disabled={!data?.sayi?.oncekiGun} className={`mr-1`}
              onClick={() => {
                fireCsEvent({
                  category: "Sayfa",
                  action: "Navigation",
                  label: "Onceki Gun"
                });
              }}
          >
            <Link to={data?.sayi?.oncekiGun ? `/gazete/${gazete}/${data?.sayi?.oncekiGun}/${1}` : '#'} >
              <div className="text-center"><BsChevronDoubleLeft size="2em"/></div>
              <div className="text-center">
                <FormattedMessage id="GazeteSayfası.oncekiGun" defaultMessage="Önceki Gün" />
              </div>
            </Link>
          </GunButonu>
          <GunButonu disabled={sayfa===1}> 
              <Link to={sayfa>1 ? `/gazete/${gazete}/${tarih}/${sayfa-1}` : undefined}
                role="button"
                aria-label={intl.formatMessage({id: "GazeteSayfası.oncekiSayfa", defaultMessage: "Önceki sayfa"})}
                onClick={() => oncekiSayfaEventFire(fireCsEvent)}
              >
                <BsChevronLeft size="2em"/>
                <div className="text-center">
                  {intl.formatMessage({id: "GazeteSayfası.oncekiSayfa", defaultMessage: "Önceki sayfa"})}
                </div>
              </Link>
            </GunButonu>
            <GunButonu disabled={sayfa>=data?.sayi?.toplamSayfa}>  
                <Link to={sayfa<data?.sayi?.toplamSayfa ? `/gazete/${gazete}/${tarih}/${sayfa+1}` : undefined}
                  role="button"
                  aria-label={intl.formatMessage({id: "GazeteSayfası.sonrakiSayfa", defaultMessage: "Sonraki sayfa"})}
                  onClick={() => {
                    fireCsEvent({
                      category: "Sayfa",
                      action: "Navigation",
                      label: "Sonraki Sayfa"
                    });
                  }}
                >
                  <BsChevronRight size="2em"/>
                  <div className="text-center">
                    {intl.formatMessage({id: "GazeteSayfası.sonrakiSayfa", defaultMessage: "Sonraki sayfa"})}
                  </div>
                </Link>
          </GunButonu>
          <GunButonu 
              disabled={!data?.sayi?.sonrakiGun} className={`ml-1`}
              onClick={() => sonrakiGunEventFire(fireCsEvent)}
          >
            <Link to={data?.sayi?.sonrakiGun ? `/gazete/${gazete}/${data?.sayi?.sonrakiGun}/${1}` : '#'}>
              <div className="text-center"><BsChevronDoubleRight size="2em"/></div>
              <div className="text-center">
                <FormattedMessage id="GazeteSayfası.sonrakiGun" defaultMessage="Sonraki Gün" />
              </div>
            </Link>
          </GunButonu>
        </Col></Row>
      </Container>}
      <Row className={`${(renderCount > 0 && !sayfaData) ? 'd-none' : ''}`}><Col>
        <UstBannerAd className="mb-1"
          key={`${gazete}_${tarih}_${sayfa}`}
          id={"gastearsivi-leaderboard-sayfa"} />
      </Col></Row>
      {!loading && sayfaData && gazeteInfo && <React.Fragment>
      <WideContainer>
        <Row className='mt-1'><Col className='ml-a mr-a'>
        <ScrollMenu>
          { !showCrop && <ActionButton onClick={onCropClick} title={intl.formatMessage({id: "GazeteSayfası.cropTooltip", defaultMessage: "Crop (Select region)"})}>
            <RiScissorsCutLine className="m-1" size={"2em"} aria-label={intl.formatMessage({id: "GazeteSayfası.cropAriaLabel", defaultMessage: "Crop"})} />
            <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.cut" defaultMessage="Crop" /></div>
          </ActionButton>}
          { showCrop && <ActionButton onClick={() => setShowCrop(false)} title={intl.formatMessage({id: "GazeteSayfası.cancelCropTooltip", defaultMessage: "Cancel cropping"})}>
            <MdCancel className="m-1" size="2em" aria-label={intl.formatMessage({id: "GazeteSayfası.cancelCropAriaLabel", defaultMessage: "Cancel"})} />
            <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.cancelCrop" defaultMessage="Cancel" /></div>
          </ActionButton> }
          { showCrop && <ActionButton onClick={onCropDone} title={intl.formatMessage({id: "GazeteSayfası.applyCropTooltip", defaultMessage: "Apply cropping"})}>
            <MdDone className="m-1" size="2em" aria-label={intl.formatMessage({id: "GazeteSayfası.applyCropAriaLabel", defaultMessage: "Apply"})} />
            <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.applyCrop" defaultMessage="Apply" /></div>
          </ActionButton> }
          <ActionButton onClick={onAddClick} title={intl.formatMessage({id: "GazeteSayfası.addToCollectionTooltip", defaultMessage: "Add to collection"})}>
            <RiAddFill className="m-1" size="2em" aria-label={intl.formatMessage({id: "GazeteSayfası.addToCollectionAriaLabel", defaultMessage: "Add to collection"})} />
            <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.add" defaultMessage="Add to collection" /></div>
          </ActionButton>
          <ActionButton onClick={onDownloadClick} title={intl.formatMessage({id: "GazeteSayfası.downloadTooltip", defaultMessage: "Download page"})}>
            <RiFileDownloadFill className="m-1" size="2em" aria-label={intl.formatMessage({id: "GazeteSayfası.downloadAriaLabel", defaultMessage: "Download"})} />
            <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.download" defaultMessage="Download" /></div>
          </ActionButton>
          {/* Page View Limit Rectangle */}
          {typeof sayfaData?.limit === 'number' && (
            <LimitBox title={intl.formatMessage({id: "GazeteSayfası.limitKalan"}, {limit: sayfaData.limit})} aria-live="polite">
              <FormattedMessage id="GazeteSayfası.limitKalan" values={{limit: sayfaData.limit}} />
            </LimitBox>
          )}
          {/* Share Buttons with tooltips */}
          <FacebookShareButton className="m-1" 
              url={shareUrl}
              beforeOnClick={() => {
                fireCsEvent({
                  category: 'Sayfa',
                  action: 'Share',
                  label: 'Facebook'
                });
              }}
              title={intl.formatMessage({id: "GazeteSayfası.shareFacebookTooltip", defaultMessage: "Share on Facebook"})}
              aria-label={intl.formatMessage({id: "GazeteSayfası.shareFacebookAriaLabel", defaultMessage: "Share on Facebook"})}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <WhatsappShareButton className="m-1" 
              url={shareUrl}
              beforeOnClick={() => {
                fireCsEvent({
                  category: 'Sayfa',
                  action: 'Share',
                  label: 'Whatsapp'
                });
              }}
              title={intl.formatMessage({id: "GazeteSayfası.shareWhatsappTooltip", defaultMessage: "Share on Whatsapp"})}
              aria-label={intl.formatMessage({id: "GazeteSayfası.shareWhatsappAriaLabel", defaultMessage: "Share on Whatsapp"})}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <PinterestShareButton className="m-1" 
              url={shareUrl}
              media={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`} 
              beforeOnClick={() => pinterestShareEvent(fireCsEvent)}
              title={intl.formatMessage({id: "GazeteSayfası.sharePinterestTooltip", defaultMessage: "Share on Pinterest"})}
              aria-label={intl.formatMessage({id: "GazeteSayfası.sharePinterestAriaLabel", defaultMessage: "Share on Pinterest"})}>
            <PinterestIcon size={32} round/>
          </PinterestShareButton>
          <TwitterShareButton className="m-1" 
              url={shareUrl}
              beforeOnClick={() => {
                fireCsEvent({
                  category: 'Sayfa',
                  action: 'Share',
                  label: 'Twitter'
                });
              }}
              title={intl.formatMessage({id: "GazeteSayfası.shareTwitterTooltip", defaultMessage: "Share on Twitter"})}
              aria-label={intl.formatMessage({id: "GazeteSayfası.shareTwitterAriaLabel", defaultMessage: "Share on Twitter"})}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          {navigator.share && (
            <ActionButton
              onClick={() => {
                if (navigator.share) {
                  navigator.share({
                    title: intl.formatMessage({id: "GazeteSayfası.title", defaultMessage: "{tarih} {ad} {tip} Page {sayfa}"}, {tarih: moment(tarih).format('LL'), ad: gazeteInfo.gorunen_ad, tip: renderTip(), sayfa}),
                    text: altTextKes(sayfaData.caption?.trim() || sayfaData.alt_text?.trim(), 120),
                    url: shareUrl
                  }).then(() => {
                    fireCsEvent({
                      category: 'Sayfa',
                      action: 'Share',
                      label: 'OS Share'
                    });
                  }).catch(() => {});
                }
              }}
              title={intl.formatMessage({id: "GazeteSayfası.shareOSTooltip", defaultMessage: "Share on device"})}
              aria-label={intl.formatMessage({id: "GazeteSayfası.shareOSAriaLabel", defaultMessage: "Share on device"})}
            >
              <RiShareFill className="m-1" size="2em" />
              <div className='mt-a mb-a'><FormattedMessage id="GazeteSayfası.osShare" defaultMessage="Share" /></div>
            </ActionButton>
          )}
        </ScrollMenu>
        </Col></Row>
        <Row>
          { showCrop && sayfaData?.limit != 0 && 
            <ReactCrop src={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`}
              crop={crop} 
              onChange={(newCrop, percentCrop) => {
                setCrop(percentCrop)
              }}
          /> }
          { !showCrop && !showZoomView 
              && <React.Fragment>
            {!sayfaData?.censored && sayfaData.limit != 0 && <SayfaImageContainer itemProp="image" itemScope itemType="https://schema.org/ImageObject">
              <meta itemProp="url" content={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`} />
              {bbox && imageDimensions && !showZoomView && (
                <BboxOverlay 
                  style={{
                    left: `${bbox.x1/imageDimensions.width*100}%`,
                    top: `${bbox.y1/imageDimensions.height*100}%`,
                    width: `${(bbox.x2-bbox.x1)/imageDimensions.width*100}%`,
                    height: `${(bbox.y2-bbox.y1)/imageDimensions.height*100}%`
                  }}
                />
              )}
              <EsasSayfaImg
                className="mt-1 mb-1"
                zoom={true}
                src={`${process.env.REACT_APP_GA_CDN_URL}/${sayfaData.dosya}`} 
                alt={intl.formatMessage({id: "GazeteSayfası.imageAlt"}, 
                  {tarih: moment(tarih).format('LL'), sayfa, tip: renderTip(), ad: gazeteInfo.gorunen_ad})
                }
                imgAttributes={{
                  crossOrigin: "anonymous",
                  onLoad: handleImageLoad
                }}
              >
                <Img width={2000} height={3000}/>
              </EsasSayfaImg>
            </SayfaImageContainer>}
          </React.Fragment> }
        </Row>
        {sayfaData?.censored && <React.Fragment>
          <Row className="d-flex justify-content-center mt-5 mb-5">
            <Col className="d-flex flex-column align-items-center" style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <h2 style={{ fontWeight: 'bold', color: '#fff', background: '#8b7d65', padding: '2rem 3rem', borderRadius: '16px', marginTop: '2rem', boxShadow: '0 2px 12px rgba(139,125,101,0.18)', textAlign: 'center', maxWidth: '700px', width: '100%' }}>
                <FormattedMessage id="GazeteSayfası.censoredLegalTitle" defaultMessage="Access to this page is restricted for legal reasons in your country." />
              </h2>
              <p style={{ fontSize: '1.2rem', color: '#8b7d65', background: '#fffbe6', padding: '1rem 2rem', borderRadius: '10px', maxWidth: '600px', textAlign: 'center', marginTop: '1.5rem', width: '100%' }}>
                <FormattedMessage id="GazeteSayfası.censoredLegalExplanation" defaultMessage="This newspaper page cannot be displayed due to legal restrictions applicable in your country." />
              </p>
            </Col>
          </Row>
        </React.Fragment>}
        {sayfaData.limit == 0 && <React.Fragment>
          <Row><Col className='d-flex justify-content-center'>
            <h3 style={{ fontWeight: 'bold', color: '#fff', background: '#8b7d65', padding: '1rem 2rem', borderRadius: '12px', marginTop: '1rem', boxShadow: '0 2px 8px rgba(139,125,101,0.15)' }}>
              <FormattedMessage id="GazeteSayfası.pageLimit" />
            </h3>
          </Col></Row>
          <Row><Col className='d-flex justify-content-center'>
            <p style={{ fontSize: '1.1rem', color: '#8b7d65', background: '#fffbe6', padding: '0.75rem 1.5rem', borderRadius: '8px', maxWidth: '500px', textAlign: 'center' }}>
              <FormattedMessage id="GazeteSayfası.limitExplanation" />
            </p>
          </Col></Row>
          {loggedIn && user?.abonelik == null &&
            <stripe-pricing-table pricing-table-id={process.env.REACT_APP_GA_SUBS_TABLE_ID}
                publishable-key={process.env.REACT_APP_GA_SUBS_PRICING_KEY}
                client-reference-id={user?.id}>
            </stripe-pricing-table>}
          {loggedIn && user?.abonelik &&
            <Row className='d-flex justify-content-center'>
              <FormButton 
                className="mt-1 mb-2" 
                style={{ fontSize: '1.5rem', minWidth: '220px', boxShadow: '0 2px 8px rgba(139,125,101,0.15)' }}
                onClick={() => window.open(process.env.REACT_APP_GA_STRIPE_CUSTOMER_PORTAL)}
                aria-label="Aboneliği düzenle veya yükselt">
                <FormattedMessage id="account.manageSubscription" defaultMessage="Aboneliği düzenle" />
              </FormButton>
            </Row>}
          {!loggedIn &&
            <Row className='d-flex justify-content-center'>
              <FormButton 
                className="mt-1 mb-2" 
                style={{ fontSize: '1.5rem', minWidth: '220px', boxShadow: '0 2px 8px rgba(139,125,101,0.15)' }}
                onClick={onAboneOlClick}
                aria-label="Abone ol">
                <FormattedMessage id="GazeteSayfası.subscribeNow" />
              </FormButton>
            </Row>}
        </React.Fragment>}
      </WideContainer>
      </React.Fragment>}
      {sayfaData && <React.Fragment>
      <Container>
        { kupurData && kupurData.length > 0 &&
          <React.Fragment>
            <Row className="m-1 mt-3"><Col>
              <h3>
                <FormattedMessage id="GazeteSayfası.küpürlerTitle" defaultMessage="Sayfaya ait küpürler" />
              </h3>
            </Col></Row>
            <Row>
            {kupurData.map((kupur) => {
              return <ColBr key={kupur.id} className="mb-5 d-flex justify-content-center" >
                <Link to={`/kupur/${kupur.id}`}>
                  <KupurImg
                      ampProps={{width: 300, height:450}}
                      src={`${process.env.REACT_APP_GA_CDN_URL}/kupur-thumbnail/${kupur.dosya}`} 
                      alt={altTextKes(kupur.icerik, 125)} 
                      loading="lazy" width="300" height="450" />
                </Link>
              </ColBr>
            })}
            </Row>
          </React.Fragment>
        }
        {sayfaData?.etiketler && <ScrollMenu>
          <DigerSayfaLink><span><FormattedMessage id="GazeteSayfası.tags" /></span></DigerSayfaLink>
          {sayfaData.etiketler.map(etiket => {
            return <DigerSayfaLink key={etiket}>
                <Link className="mr-1" 
                    onClick={() => {
                      fireCsEvent({
                        category: "Sayfa",
                        action: "Navigation",
                        label: "Etiket linkine tıklandı"
                      })
                    }} 
                    to={generatePath("/etiket/:ad", {ad: etiket.toLocaleLowerCase('tr')})}
                >
                  {etiket}
                </Link>
              </DigerSayfaLink>
          })}
        </ScrollMenu>}
        {gunSayilari && gunSayilari.length > 0 && <React.Fragment>
          <Row><Col>
            <Link to={`/tarih/${tarih}`} >
              <h2 className='mt-2 mb-2'>
                <FormattedMessage id="GazeteSayfası.aynıGün" 
                  defaultMessage="Aynı gün çıkan diğer gazeteler" />
              </h2>
            </Link>
          </Col></Row>
          <ScrollMenu>
          {gunSayilari.filter(sayi => {
            return gazeteler[sayi?.gazete] 
              && gazeteler[sayi?.gazete] !== gazete
          }).map((sayi, i) => { 
            const gazete = gazeteler[sayi?.gazete];
            return <React.Fragment key={`gunSayilari ${i}`}>
              <GunSayisiCol
                  itemScope itemType="https://schema.org/Article"
                  className="d-flex justify-content-center" >
                <Link itemProp="mainEntityOfPage"
                    onClick={() => {
                      fireCsEvent({
                        category: "Sayfa",
                        action: "Navigation",
                        label: "Aynı gün gazetesine tıklandı"
                      })
                    }}
                    to={`/gazete/${gazete.gazete}/${tarih}/${sayi.sayfa}`}>
                  <h3 className='d-flex justify-content-center'>{gazete.gorunen_ad}</h3>
                  <SayfaImg
                      ampProps={{width: 300, height:450}}
                      src={`${process.env.REACT_APP_GA_CDN_URL}/${sayi.thumbnail}`} 
                      alt={`${gazete.gorunen_ad} sayfa ${sayi.sayfa}`}
                      loading="lazy" width="300" height="450" />
                </Link>
              </GunSayisiCol>
            </React.Fragment>
          })}
          </ScrollMenu>
        </React.Fragment>}
        {sayfaData.alt_text && 
          <Metin className="mb-1 mt-2"><Col>
            <span><FormattedMessage id="GazeteSayfası.metinİçeriği" 
                defaultMessage="Metin içeriği (otomatik olarak oluşturulmuştur)" />
            </span>
            {(() => {
              const text = sayfaData.alt_text.replace(/(\n+ *)+/g, "\n");
              return <p itemProp="articleBody">{text}</p>
            })()}
          </Col></Metin>
        }
        {data?.sayi?.toplamSayfa && <React.Fragment>
          <h3 className='mt-2 mb-2'><FormattedMessage id="GazeteSayfası.digerSayfalar"/></h3>
          <ScrollMenu>
          {range(data?.sayi?.toplamSayfa).map((sayfa) => {
            return <React.Fragment key={`sayfa ${sayfa+1}`}>
              <DigerSayfaLink>
                <Link className="mr-1" to={`/gazete/${gazete}/${tarih}/${sayfa+1}`}>
                  <FormattedMessage id="GazeteSayısı.sayfaTitle" 
                      values={{sayfa: sayfa+1}} />
                </Link>
              </DigerSayfaLink>
            </React.Fragment>
          })}
          </ScrollMenu>
        </React.Fragment>}
      </Container>
    </React.Fragment>} 
    {/* Back to Top Button */}
    {showBackToTop && (
      <BackToTopButton 
        onClick={scrollToTop} 
        aria-label={intl.formatMessage({id: "GazeteSayfası.backToTopAriaLabel", defaultMessage: "Back to top"})}
        title={intl.formatMessage({id: "GazeteSayfası.backToTopTooltip", defaultMessage: "Back to top"})}
      >
        ↑
      </BackToTopButton>
    )}
    </React.Fragment>
}

export default withRouter(GazeteSayfasi);
